"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../assets/icons");

var _Icon = require("./Icon.style");

var _excluded = ["size", "iconName", "className", "onClick", "hoverColor"];

var Icon = function Icon(_ref) {
  var size = _ref.size,
      iconName = _ref.iconName,
      className = _ref.className,
      onClick = _ref.onClick,
      hoverColor = _ref.hoverColor,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var IconComponent = _icons.Icons[iconName];
  return IconComponent ? /*#__PURE__*/_react["default"].createElement(_Icon.StyledIcon, {
    className: className,
    onClick: onClick,
    hoverColor: hoverColor
  }, /*#__PURE__*/_react["default"].createElement(IconComponent, (0, _extends2["default"])({
    size: size
  }, props))) : null;
};

Icon.defaultProps = {
  size: '20',
  fill: '#000000'
};
Icon.propTypes = {
  size: _propTypes["default"].string,
  iconName: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,

  /**
   a callback func, which takes `event` argument
   */
  onClick: _propTypes["default"].func,
  fill: _propTypes["default"].string,
  hoverColor: _propTypes["default"].string
};
var _default = Icon;
exports["default"] = _default;